import { render, staticRenderFns } from "./ListReceipt.vue?vue&type=template&id=c47444a4&"
import script from "./ListReceipt.vue?vue&type=script&lang=ts&"
export * from "./ListReceipt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports